export default "__VITE_ASSET__DUKsf9yQ__"